import { Entity } from 'vortex';
import { PANEL_INDEX } from '../constants/game-constants';
import { BOARD_RECT } from '../constants/graphics-constants';

export class Panel extends Entity {
    hideIfOpponent = false

    getMirrorPoint() {
        if (this.owner.isOpponent) {
            return { y: BOARD_RECT.y };
        } else {
            return null;
        }
    }

    getOrderIndex() {
        return PANEL_INDEX;
    }
}